import { userLink } from './user-link';

export const foreignRecords = ($http: HttpApi) => ({
  get: (viewId: string, { fieldId, recordId }: { fieldId: string, recordId: string }) => $http.$get(`/views/${viewId}/fields/${fieldId}/links`, {
    params: { record_id: recordId },
  }),
  userLink: userLink($http),
});
